/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * Conversion Reporting API
 * API for querying conversion and reporting data from PostgreSQL.

## Reporting (Async Query Pattern)
Reporting and lead-export queries use an async job-polling pattern:

1. **Submit** a query via `POST /reporting/queries` -- returns a `queryId` immediately
2. **Poll** status via `GET /reporting/queries/{queryId}` until `status` is `completed`
3. **Results** are included inline in the status response when complete
4. **Cancel** a running query via `DELETE /reporting/queries/{queryId}`

## Pagination
Reporting results support both offset-based and cursor-based pagination.
Cursor-based pagination (`nextCursor`) is recommended for large datasets.
 * OpenAPI spec version: 1.0.0
 */

export type CalculatedMetricTargetMode = typeof CalculatedMetricTargetMode[keyof typeof CalculatedMetricTargetMode];


export const CalculatedMetricTargetMode = {
  new: 'new',
  override: 'override',
} as const;
